/* eslint-disable max-len */
const affiliateUrls = [
  "amazon.com",
  "bollandbranch.com",
  "butcherbox.com",
  "coyuchi.com",
  "credobeauty.com",
  "cwhemp.com",
  "elysiumhealth.com",
  "etsy.com",
  "everlane.com",
  "everlywell.com",
  "globein.com",
  "humnutrition.com",
  "kohls.com",
  "marleyspoon.com",
  "parachutehome.com",
  "planttherapy.com",
  "rxbar.com",
  "sagelynaturals.com",
  "shop.lululemon.com",
  "shop.nordstrom.com",
  "skylarbody.com",
  "succulent.studio",
  "thedetoxmarket.com",
  "thereformation.com",
  "thredup.com",
  "thrivemarket.com",
  "truebotanicals.com",
  "violetgrey.com",
  "weightingcomforts.com",
  "zenhaven.com",
]

const addLinkTracking = ({ articleId, text, partnerIds }) => {
  if (!text) {
    return ""
  }

  try {
    const rewriteLink = ({ link }) => {
      let newLink = link
      // add itc tracking to classes and shop links
      // first remove existing itc_content from link
      newLink = newLink.replace(/(\?|&)itc_content=[\d]+/, "")
      if (
        // eslint-disable-next-line max-len
        /^https?:\/\/(www\.)?(shop|calm|coaching|institute)\.mindbodygreen\.com|(https?:\/\/(www\.)?mindbodygreen\.com)?\/(classes|coaching|landing)/.test(
          newLink,
        )
      ) {
        newLink +=
          newLink.includes("?") > 0 ? `&itc_content=${articleId}` : `?itc_content=${articleId}`
      }
      return newLink
    }

    // check if the string is just a URL that starts with http(s) or just /
    // and has no whitespace and rewrite it
    if (text.match(/^(https?:\/)?\/[^\s]+$/)) {
      return rewriteLink({ link: text })
    }

    // get all links and then handle replacements
    const newText = text.replace(/<a([^>]*)href="(.*?)"([^>]*)>(.*?)<\/a>/g, (...args) => {
      const [match, beforeLink, link, afterLink, linkText] = args
      // if the link is to the citations modal, don't add tracking
      if (link.match(/#citations/)) return match
      const newLink = rewriteLink({ link })
      // if returned value is null, the link was removed
      if (!newLink) return linkText

      const hasRel = /rel=/.test(beforeLink) || /rel=/.test(afterLink)
      const hasTarget = /target=/.test(beforeLink) || /target=/.test(afterLink)
      const hasTracking = /mbg-track-event/.test(match)
      const trustedSite = /\.(gov|edu|org)\//.test(newLink)

      // build response from all elements

      let response = `<a href="${newLink}"`
      if (!hasTarget) response += ` target="_blank"`
      /**
       * nofollow rules
       * - link has a rel value already
       * - or branded / sponsored links unless they are mbg content or trusted sources
       * - or is shop/calm.mindbodygreen.com links (sponsored)
       * - or is trackonomics link (sponsored)
       * - or is known affiliate link (sponsored)
       * */
      if (hasRel) {
        let relValue = "nofollow"
        if (/rel=/.test(beforeLink)) {
          ;[, , relValue] = beforeLink.match(/rel=(\"|')([^\"']+)(\"|')/)
        } else if (/rel=/.test(afterLink)) {
          ;[, , relValue] = afterLink.match(/rel=(\"|')([^\"']+)(\"|')/)
        }
        response += ` rel="${relValue}"`
      } else if (
        (!!partnerIds &&
          !/\.(gov|edu|org)\//.test(newLink) &&
          !/mindbodygreen\.com\//.test(newLink)) ||
        /\/\/(shop|calm)\.mindbodygreen\.com\//.test(newLink) ||
        /clicks\.trx-hub/.test(newLink) ||
        affiliateUrls.some((url) => newLink.includes(url))
      ) {
        response += ' rel="sponsored"'
      }

      // add click tracking
      if (!hasTracking) {
        response +=
          ' class="mbg-track-event" data-track-event-types="click" data-track-type="article-link" '
        // different tracking required depending upon if a class, shop link, or other
        if (/\/classes\//.test(newLink)) {
          const parts = newLink.match(/\/classes\/([A-Za-z0-9-]+)/)
          if (parts) {
            const [, cls] = parts
            response += `data-track-prop-element-id=\"in-body-class-link" data-track-prop-class="${cls}" data-track-prop-label="page_type|element_id" data-track-prop-category="Class Engagement"`
            try {
              if (cls !== "topics" && classes) {
                const { id } = classes.find(({ relativeUrl }) => relativeUrl === `/classes/${cls}`)
                if (id) {
                  response += ` data-track-prop-product-id="${id}"`
                }
              }
            } catch (err) {
              // ignore
            }
          }
        } else if (/\/\/(shop|calm)\.mindbodygreen\.com/.test(newLink)) {
          const parts = newLink.match(/\/(products|collections|bundles|pages)\/([A-Za-z0-9-]+)/)
          let product = "home"
          if (parts) {
            ;[, , product] = parts
          }
          response += `data-track-prop-element-id=\"in-body-product-link" data-track-prop-product="${product}" data-track-prop-label="page_type|element_id" data-track-prop-category="Commerce Engagement"`
        } else {
          // if the newLink is a Trackonomics link, use the original link for tracking
          const trackLink = /clicks\.trx-hub/.test(newLink) ? link : newLink
          response += `data-track-prop-element-id=\"in-body-link" data-track-prop-label="page_type | element_id" data-track-prop-category="Link" data-track-prop-link="${trackLink}"`
        }
      }

      response += `>${linkText}</a>`
      return response
    })
    return newText
  } catch (err) {
    console.log(err)
  }

  return text
}

export const addItcContentToString = (url, articleId) => {
  if (needToAddItc(url)) {
    const separator = url.includes("?") ? "&" : "?"
    const updatedUrl = `${url}${separator}itc_content=${articleId}`
    return updatedUrl
  }
  return url
}

export const needToAddItc = (url) =>
  /^https?:\/\/(www\.)?(shop|calm|coaching|institute)\.mindbodygreen\.com|(https?:\/\/(www\.)?mindbodygreen\.com)?\/(classes|coaching|landing)/.test(
    url,
  )

export const addItcContent = (obj, articleId) => {
  if (obj && typeof obj === "object") {
    for (const key in obj) {
      const val = obj[key]
      if (
        typeof val === "string" &&
        val.includes("mindbodygreen.com") &&
        !val.includes("itc_content")
      ) {
        if (needToAddItc(val)) {
          try {
            const newUrl = new URL(val)
            newUrl.searchParams.set("itc_content", articleId)
            obj[key] = newUrl.toString()
          } catch {}
        } else {
          val.replace(/<a([^>]*)href="(.*?)"([^>]*)>(.*?)<\/a>/g, (...args) => {
            const [match, , link] = args
            if (needToAddItc(link)) {
              const newLink =
                link.indexOf("?") > 0
                  ? `${link}&itc_content=${articleId}`
                  : `${link}?itc_content=${articleId}`
              const indexObject = obj[key].indexOf(match)
              const secondWordIndex = obj[key].substr(indexObject + match.length)
              const firstPart = obj[key].substr(0, indexObject)
              const newWord = match.replace(link, newLink)
              obj[key] = firstPart + newWord + secondWordIndex
            }
          })
        }
      }
      if (typeof val === "object") {
        addItcContent(val, articleId)
      }
    }
  }
}

export default function (articleId, partnerIds, elements) {
  try {
    elements.forEach((element) => {
      const { type, url, text, items, products } = element

      if (url) {
        element.url = addLinkTracking({
          articleId,
          text: url,
          partnerIds,
        })
      }

      if (text) {
        const cleanText = addLinkTracking({
          articleId,
          text,
          partnerIds,
        })
        element.text = cleanText
      }

      // if a list, addLinkTracking on the list items
      if (type === "list" && items) {
        items.forEach((item) => {
          item.text = addLinkTracking({
            articleId,
            text: item.text,
            partnerIds,
          })
        })
      }

      // if a product, addLinkTracking on the product url
      products?.forEach((product) => {
        if (product.url) {
          product.url = addLinkTracking({
            articleId,
            text: product.url,
            partnerIds,
          })
        }
      })

      if (type === "review" && items) {
        items.forEach((item) => {
          // clean the links in the item description
          if (item.description) {
            item.description = addLinkTracking({
              articleId,
              text: item.description,
              partnerIds,
            })
          }
          if (item.sources) {
            // replace source links params with itc_content if they are mindbodygreen links
            item.sources.forEach((source) => {
              try {
                source.url = addLinkTracking({
                  articleId,
                  text: source.url,
                  partnerIds,
                })
                if (source.promotion?.url) {
                  source.promotion.url = addLinkTracking({
                    articleId,
                    text: source.promotion.url,
                    partnerIds,
                  })
                }
              } catch (err) {
                // ignore
              }
            })
          }
        })
      }
    })
  } catch (err) {
    console.log(err)
  }
}
